module.exports = __webpack_public_path__ + "static/media/Cittadella.2e6425a4.png";